import { createGlobalStyle } from 'styled-components';
import { ThemeProviderColors, ThemeProps } from '../interfaces';

export const TimesheetStyle = createGlobalStyle`
  [class*='ms-Callout-main'] [class*='ms-DatePicker'] {
    background-color: ${(props: ThemeProps<ThemeProviderColors>) =>
      props.theme.timesheetsDatepickerBackground};
  }

  [class*='monthAndYear-'] span {
    color: ${(props: ThemeProps<ThemeProviderColors>) =>
      props.theme.timesheetsDatepikerColor};
  }

  [class*='dayCell-'] {
    color: ${(props: ThemeProps<ThemeProviderColors>) =>
      props.theme.timesheetsDatepikerColor};
  }

  [class*='headerIconButton-'] i {
    color: ${(props: ThemeProps<ThemeProviderColors>) =>
      props.theme.timesheetsDatepikerColor};
  }
  
  [data-icon-name*='Calendar'] {
    visibility: hidden;
  }

  [class*='ms-TextField-field'] {
    background: unset;
    border: none;
  }

  [id*='id-label'] {
    border: none;
    color: transparent;
  }

  td[class*='dayCell-']::before {
    border: none;
  }

  [class*='daySelected-'] {
    background-color: ${(props: ThemeProps<ThemeProviderColors>) =>
      props.theme.timesheetsDatepickerWeekSelectedBackGround} !important;
  }
  
  [class*='ms-CalendarDay-hover'] {
    background-color: ${(props: ThemeProps<ThemeProviderColors>) =>
      props.theme.timesheetsDatepickerWeekHoverBackGround} !important;
  }

  [class*='dayCell-'][class*='ms-CalendarDay-daySelected'] {
    background-color: ${(props: ThemeProps<ThemeProviderColors>) =>
      props.theme.timesheetsDatepickerSelectedWeekHoverBackGround} !important;
  }

  [class*='monthAndYear-'] span {
    font-size: 0.875rem;
    font-weight: 700;
  }
`;
